import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import IconDelete from '../../ui/Icons/IconClose';

class SavedSearchDeleteModal extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { visible, onClose, onReject, onSubmit } = this.props;
    return (
      <div className='modal-map'>
        <Modal
          isOpen={visible}
          onRequestClose={onClose}
          portalClassName='saved-search-modal'
          className='saved-search-modal__content'
          overlayClassName='saved-search-modal__overlay'
        >
          <div className='saved-search-modal-title'>
            <div className='header'>Удалить сохраненный поиск?</div>
            <button type='button' className='close' onClick={onClose}><IconDelete /></button>
          </div>

          <div className='saved-search-modal-container'>
            <button onClick={onReject} className='btn-base btn-primary submit'>
              Отмена
            </button>
            <button onClick={onSubmit} className='btn-base btn-hollow submit'>
              Удалить
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}

SavedSearchDeleteModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SavedSearchDeleteModal;



// WEBPACK FOOTER //
// ./src/app/SavedSearch/SavedSearchDeleteModal.jsx